import React from 'react';
import styled from 'styled-components';
import { Text } from '@solvhealth/jigsaw-v1';
import RecentlyBookedIcon from '../../../../../../../components/SolvPatternLibrary/Icons/RecentlyBooked';
import { fontFamily } from '../../../../../../../constants/text';
import { pluralize } from '../../../../../../../core/util/string';
import { colors } from '../../../../../../../constants/colors';
import { getCount } from './util';

const StyledRecentlyBookedIcon = styled(RecentlyBookedIcon).withConfig({ componentId: 'sc-1y80amn-0' })`
  margin-right: 16px;
  path {
    fill: ${colors.peaches};
  }
`;

const StrongText = styled.span.withConfig({ componentId: 'sc-1y80amn-1' })`
  font-family: ${fontFamily.bold};
  padding-right: 2px;
  white-space: nowrap;
`;

type OwnProps = {
  physicalLocationRecentBookings?: number;
  associatedTelemedLocationRecentBookings?: number;
  showIcon?: boolean;
};

// @ts-expect-error ts-migrate(2456) FIXME: Type alias 'Props' circularly references itself.
type Props = OwnProps & typeof Copy.defaultProps;

// @ts-expect-error ts-migrate(7022) FIXME: 'Copy' implicitly has type 'any' because it does n... Remove this comment to see the full error message
const Copy = (props: Props) => {
  const { physicalLocationRecentBookings, associatedTelemedLocationRecentBookings, showIcon } =
    props;

  const count = getCount(physicalLocationRecentBookings, associatedTelemedLocationRecentBookings);

  if (count < 6) {
    return (
      <>
        <Text paddingX={1} variant="body2">
          <StrongText>Book now!</StrongText> Instantly secure your spot.
        </Text>
        {showIcon && <StyledRecentlyBookedIcon />}
      </>
    );
  }

  if (count > 120) {
    return (
      <>
        <Text paddingX={1} variant="body2">
          <StrongText>Book now!</StrongText> This is a popular clinic.
        </Text>

        {showIcon && <StyledRecentlyBookedIcon />}
      </>
    );
  }

  return (
    <>
      <Text paddingX={1} variant="body2">
        <StrongText>Popular Clinic!</StrongText>
        Booked on Solv {count} {pluralize(count, 'time')} today
      </Text>

      {showIcon && <StyledRecentlyBookedIcon />}
    </>
  );
};

Copy.defaultProps = {
  showIcon: true,
};

export default Copy;
